import { render, staticRenderFns } from "./Supervision.vue?vue&type=template&id=d663c7aa&scoped=true&"
import script from "./Supervision.vue?vue&type=script&lang=ts&"
export * from "./Supervision.vue?vue&type=script&lang=ts&"
import style0 from "./Supervision.vue?vue&type=style&index=0&id=d663c7aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d663c7aa",
  null
  
)

export default component.exports